@if (isLoading()) {
  <div class="bg-background-overlay absolute inset-0 z-10 flex h-full w-full items-center justify-center" role="status">
    <div class="gap-xl flex flex-col items-center">
      <hlm-spinner class="text-white" icon="lucideLoaderCircle" hlmTooltipTrigger="Duplication en cours" size="128px" />
      <div class="flex flex-col text-center text-white">
        <span class="title-medium-semibold">Import du module en cours</span>
        <span>Vous pouvez créer d'autres module pendant l'importation.</span>
      </div>
    </div>
  </div>
}

<div class="gap-md flex flex-col">
  <app-expansion-panel
    [isOpen]="true"
    titre="{{ cartographie.value?.nom ?? 'Cartographie' }} &middot; {{
      referentielFC.value?.nom ?? 'Métier'
    }} &middot; {{ parcoursFC.value?.nom ?? 'Parcours' }}"
  >
    <div class="gap-lg p-md grid" [formGroup]="form">
      <div hlmField>
        <label for="select-cartographie" hlmFieldLabel labelRequired>Choix de la cartographie</label>
        <hlm-select id="select-cartographie" formControlName="cartographie">
          <hlm-select-trigger>
            <hlm-select-value />
          </hlm-select-trigger>

          <hlm-select-content>
            @for (item of cartographies() | trierPar: 'nom'; track item.id) {
              <hlm-option [value]="item">
                {{ item.nom }}
              </hlm-option>
            }
          </hlm-select-content>
        </hlm-select>
      </div>

      <div hlmField>
        <label for="select-cartographie" hlmFieldLabel labelRequired>Choix du référentiel</label>
        <hlm-select id="select-referentiel" formControlName="referentiel">
          <hlm-select-trigger>
            <hlm-select-value />
          </hlm-select-trigger>

          <hlm-select-content>
            @for (item of referentiels() | trierPar: 'nom'; track item.id) {
              <hlm-option [value]="item">
                {{ item.nom }}
              </hlm-option>
            }
          </hlm-select-content>
        </hlm-select>
      </div>

      <div hlmField>
        <label for="select-parcours" hlmFieldLabel labelRequired>Choix du parcours</label>
        <hlm-select id="select-parcours" formControlName="parcours">
          <hlm-select-trigger>
            <hlm-select-value />
          </hlm-select-trigger>

          <hlm-select-content>
            @for (item of parcours() | trierPar: 'nom'; track item.id) {
              <hlm-option [value]="item">
                {{ item.nom }}
              </hlm-option>
            }
          </hlm-select-content>
        </hlm-select>
      </div>
    </div>
  </app-expansion-panel>

  @if (parcoursFC.value) {
    <hlm-separator />

    <div class="gap-lg flex flex-col">
      <div hlmField>
        <label for="input-etape" hlmFieldLabel>Module</label>
        <div hlmInputGroup>
          <input
            [(ngModel)]="rechercheModule"
            [ngModelOptions]="{ standalone: true }"
            hlmInputGroupInput
            placeholder="Recherchez un module"
          />
          <div hlmInputGroupAddon align="inline-end">
            <ng-icon name="lucideSearch" hlm size="xs" />
          </div>
        </div>
      </div>
    </div>

    <div class="gap-sm flex flex-col">
      <span class="text-content-secondary">Sélectionnez un module.</span>

      <hlm-radio-group class="gap-xs flex flex-col !space-y-0 !space-x-0" [(ngModel)]="moduleSelectionne">
        @for (module of modulesFiltres(); track module.id) {
          <label [class]="cardClass" hlmLabel>
            <hlm-radio class="!m-0 !p-0 hover:bg-inherit" [value]="module">
              <app-item-module [module]="module" />
            </hlm-radio>
          </label>
        }
      </hlm-radio-group>
    </div>
  }
</div>
